// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3l3CK","content":"styles_content__3uLfe","selectAll":"styles_selectAll__wgY4v"};